function coordinate(value, limit) {
  if (value == null || (typeof value === "string" && !value.trim())) {
    return undefined;
  }
  if (typeof value !== "number" && typeof value !== "string") {
    return undefined;
  }
  const number = Number(value);
  return Number.isFinite(number) && Math.abs(number) <= limit ? number : undefined;
}

/** Projects geocoded results into marker positions without changing the prepared card records. */
export function markerRecords(records = []) {
  return records.flatMap((result) => {
    const lat = coordinate(result?.lat, 90);
    const lng = coordinate(result?.lng, 180);
    if (!result?.resultGUID || lat === undefined || lng === undefined) {
      return [];
    }
    return [{ result, position: { lat, lng } }];
  });
}

/** Groups physicians sharing an address; each co-located Location remains a distinct practice. */
export function addressGroups(records) {
  const groups = new Map();
  for (const result of records) {
    const location = result.resultType === "Location";
    const key = location ? `location:${result.resultGUID}` : JSON.stringify([result.street_address, result.zip_code]);
    if (!groups.has(key)) {
      groups.set(key, { result, providers: [], locations: [] });
    }
    groups.get(key)[location ? "locations" : "providers"].push(result);
  }
  return [...groups.values()];
}
